import { Component, OnInit } from '@angular/core';
import { DeviceDetector } from 'projects/ui-kit/src/lib/services/device-detector.service';

@Component({
  selector: 'app-influences-interaction',
  templateUrl: './influences-interaction.component.html',
  styleUrls: ['./influences-interaction.component.scss']
})
export class InfluencesInteractionComponent extends DeviceDetector {
  interactionTypes = {
    like: 'like',
    dislike: 'dislike',
    love: 'love'
  };
  selected = '';
  constructor() {
    super();
  }

}
